<div class="modal active">
  <div class="modal__container user-support-ticket-modal">
    <div class="fields">
      <h2>{{ modalTitle }}</h2>
      <div class="close" (click)="bsModalRef.hide()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>

      <div class="fields__container">
        <form autocomplete="off" class="active" name="newTicketForm" #newTicketForm="ngForm">
          <div class="fields__block">
            <label>
              Title *
              <input
                type="text"
                name="headerTitle"
                maxlength="255"
                [(ngModel)]="headerTitle"
              />
            </label>
            <label>
              Type *
              <select
                class="ticket-type-select"
                name="ticketType"
                [(ngModel)]="ticketType">
                <option value="DEFECT">Defect</option>
                <option value="IMPROVEMENT">Improvement</option>
              </select>
            </label>

            <label>
              Description *
              <textarea
                name="ticketDescription"
                rows="6"
                [(ngModel)]="description"
              ></textarea>
            </label>

            <section class="attachments">
              <h3>Attachments</h3>

              <div class="attachment-list">
                <div class="attachment-row" *ngFor="let item of attachments; let i = index">
                  <div class="attachment-info">
                    <strong>{{ item.name }}</strong>
                    <div class="attachment-meta">
                      <span>{{ item.type || 'Unknown type' }}</span>
                      <span>{{ formatFileSize(item.size) }}</span>
                    </div>
                  </div>
                  <div class="attachment-actions">
                    <button
                      type="button"
                      class="attachment-remove-btn"
                      title="Remove attachment"
                      [attr.aria-label]="'Remove ' + item.name"
                      (click)="removeAttachment(i)">
                      <img src="/assets/img/trash-icon.svg" alt="" />
                    </button>
                  </div>
                </div>

                <div class="empty-state" *ngIf="attachments.length === 0">
                  No attachments yet.
                </div>
              </div>

              <div class="attachment-upload-row">
                <label class="file-select-btn">
                  <img src="/assets/img/upload-file-icon.svg" alt="" />
                  <span>Choose Files</span>
                  <input
                    type="file"
                    multiple
                    accept=".png,.jpg,.jpeg,.pdf,.txt,.log,.zip,image/png,image/jpeg,application/pdf,text/plain,application/zip,application/x-zip-compressed"
                    name="attachmentsFileInput"
                    (change)="onFilesSelected($event)" />
                </label>
              </div>

              <div class="selected-files">
                {{ attachments.length }} of {{ maxFiles }} files ·
                {{ formatFileSize(totalAttachmentSize) || '0 B' }} of {{ maxTotalSizeMb }} MB
              </div>
              <div class="attachment-help">
                Supported files: PNG, JPG, PDF, TXT, LOG and ZIP. Maximum total size is {{ maxTotalSizeMb }} MB.
              </div>
            </section>
          </div>

          <div class="fields__btn">
            <button type="button" class="blue" (click)="submitTicket()" [disabled]="creating || !isFormValid()">
              Submit Ticket
            </button>
            <button type="button" class="gray" (click)="bsModalRef.hide()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
